import { useEffect } from 'react';

import { type Product, type ProductData } from '../../common/types';
import { RemoteActionsPollingService } from '../../services/remote-actions-polling-service';
import { useRemoteActions } from '../../services/remote-actions-store';

export const useRemoteActionsOnInterval = ({
	endpoint,
	product,
	productData,
	onPollingError,
	pollingInterval,
	idleTime,
}: {
	endpoint: string;
	idleTime?: number | undefined;
	onPollingError: (error: unknown) => void;
	pollingInterval?: number | undefined;
	product: Product;
	productData: ProductData;
}) => {
	const [{ isLoaded }, { processRemoteActions }] = useRemoteActions((state) => ({
		isLoaded: state.isLoaded,
	}));

	useEffect(() => {
		if (!isLoaded) {
			return;
		}
		const remoteActionPollingService = new RemoteActionsPollingService(
			endpoint,
			product,
			(response) => {
				processRemoteActions(productData, response);
			},
			onPollingError,
			pollingInterval,
			idleTime,
		);

		return () => remoteActionPollingService.destroy();
	}, [
		processRemoteActions,
		isLoaded,
		product,
		productData,
		onPollingError,
		endpoint,
		pollingInterval,
		idleTime,
	]);
};
